import { useCallback, useEffect } from "react";

// Only allows effect to be called after delay ms
export const useDebouncedEffect = (effect: React.EffectCallback, delay: number, deps: React.DependencyList): void => {
    const callback = useCallback(effect, deps);

    useEffect(() => {
        const handler = setTimeout(() => {
            callback();
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [callback, delay]);
};
